import { useAuthStore } from '~/stores/auth'

export default defineNuxtRouteMiddleware(() => {
  const store = useAuthStore()
  if (!store.canGetQuotes) {
    return navigateTo({ name: 'dashboard' })
  }

  return null
})
